import React from "react";
import { useLanguage } from "../context/LanguageContext";
import CurvedPortfolioShowcase from "../components/CurvedPortfolioShowcase";
import LandscapeCta from "../components/LandscapeCta";

export default function PortfolioPage() {
  const { t } = useLanguage();
  const items = t.portfolio.items;
  const ctaSubtitle = t.portfolio.cta_subtitle;

  return (
    <main className="bg-white" data-testid="portfolio-page">
      <CurvedPortfolioShowcase copy={t.portfolio} items={items} />

      <LandscapeCta
        eyebrow={t.portfolio.eyebrow}
        title={t.portfolio.cta}
        subtitle={ctaSubtitle}
        buttonLabel={t.nav.cta}
        testId="portfolio-cta-section"
        buttonTestId="portfolio-cta"
      />
    </main>
  );
}
